"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var useDuesSponsoredOrgContext_1 = require("../../global/hooks/useDuesSponsoredOrgContext");
var useErrorContext_1 = require("../../global/hooks/useErrorContext");
var useAuthenticationContext_1 = require("../../global/hooks/useAuthenticationContext");
var react_1 = require("react");
//This custom hook is responsible for making a GET request to the REACT_APP_API_GET_ALL_ILP_BY_ORG api endpoint. 
//This api returns an array of IReviewerView objects.
function useGetPlansByOrg() {
    var _this = this;
    var _a;
    var setError = (0, useErrorContext_1.useErrorContext)().setError;
    var cstKey = (0, useAuthenticationContext_1.useAuthenticationContext)().cstKey;
    var _b = (0, react_1.useState)(true), loading = _b[0], setLoading = _b[1];
    var selectedOrganization = (0, useDuesSponsoredOrgContext_1.useDuesSponsoredOrgContext)().selectedOrganization;
    var API_GET_BY_ORG = process.env.REACT_APP_API_GET_ALL_ILP_BY_ORG;
    var INELIGIBLE_ERROR_TEXT = (_a = process.env.REACT_APP_ILP_INELIGIBLE_ERROR_TEXT) !== null && _a !== void 0 ? _a : null;
    var apiGetByOrgEndpoint = "".concat(API_GET_BY_ORG).concat(selectedOrganization === null || selectedOrganization === void 0 ? void 0 : selectedOrganization.OrganizationKey, "&customerKey=").concat(cstKey);
    var handleError = function (message, statusCode) {
        setError({ message: message, statusCode: statusCode });
        setLoading(false);
        return null;
    };
    var getPlansByOrgFetch = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, result, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, 4, 5]);
                    setLoading(true);
                    console.log("CustomerKey: " + cstKey);
                    if (cstKey === undefined)
                        return [2 /*return*/, null];
                    return [4 /*yield*/, fetch(apiGetByOrgEndpoint)];
                case 1:
                    response = _b.sent();
                    if (!response.ok) {
                        console.log('useGetPlansByOrg', response.statusText);
                        if (response.status === 401 || response.status === 403) {
                            return [2 /*return*/, handleError(INELIGIBLE_ERROR_TEXT, -response.status)];
                        }
                        else {
                            return [2 /*return*/, handleError(null, -11)];
                        }
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    result = _b.sent();
                    if (!result) {
                        return [2 /*return*/, handleError(null, -22)];
                    }
                    else {
                        if (!result.Succeeded && result.Errors !== null) {
                            return [2 /*return*/, handleError(null, -33)];
                        }
                    }
                    return [2 /*return*/, (_a = result.Data) === null || _a === void 0 ? void 0 : _a.ReviewerViews];
                case 3:
                    error_1 = _b.sent();
                    console.log('useGetPlansByOrg error', error_1);
                    return [2 /*return*/, handleError(null, -error_1.status)];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Return the fetch function and the loading state
    return [getPlansByOrgFetch, loading];
}
exports.default = useGetPlansByOrg;
//# sourceMappingURL=useGetPlansByOrg.js.map